/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustRecordListResVo
 */
export interface AdminStockAdjustRecordListResVo {
    /**
     * 调整记录编号
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    adjustRecordNo?: string;
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockAdjustRecordListResVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    userName?: string;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    skuCode?: string;
    /**
     * 调整数量（正数增加，负数减少）
     * @type {number}
     * @memberof AdminStockAdjustRecordListResVo
     */
    adjustedQty?: number;
    /**
     * 调整原因编码，见 StockAdjustReasonEnum
     * @type {number}
     * @memberof AdminStockAdjustRecordListResVo
     */
    adjustReasonCode?: number;
    /**
     * 调整原因（按当前语言）
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    adjustReason?: string;
    /**
     * 操作员
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    operatorName?: string;
    /**
     * 调整前数量（货位可用量）
     * @type {number}
     * @memberof AdminStockAdjustRecordListResVo
     */
    beforeAdjustQuantity?: number;
    /**
     * 调整后数量（货位可用量）
     * @type {number}
     * @memberof AdminStockAdjustRecordListResVo
     */
    afterAdjustQuantity?: number;
    /**
     * 调整批次（库存订单号）
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    batchNo?: string;
    /**
     * 货位号，格式：货位/唛头
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    locationNo?: string;
    /**
     * 调整时间
     * @type {string}
     * @memberof AdminStockAdjustRecordListResVo
     */
    adjustTime?: string;
}

/**
 * Check if a given object implements the AdminStockAdjustRecordListResVo interface.
 */
export function instanceOfAdminStockAdjustRecordListResVo(value: object): value is AdminStockAdjustRecordListResVo {
    return true;
}

export function AdminStockAdjustRecordListResVoFromJSON(json: any): AdminStockAdjustRecordListResVo {
    return AdminStockAdjustRecordListResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustRecordListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustRecordListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'adjustRecordNo': json['adjustRecordNo'] == null ? undefined : json['adjustRecordNo'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'adjustedQty': json['adjustedQty'] == null ? undefined : json['adjustedQty'],
        'adjustReasonCode': json['adjustReasonCode'] == null ? undefined : json['adjustReasonCode'],
        'adjustReason': json['adjustReason'] == null ? undefined : json['adjustReason'],
        'operatorName': json['operatorName'] == null ? undefined : json['operatorName'],
        'beforeAdjustQuantity': json['beforeAdjustQuantity'] == null ? undefined : json['beforeAdjustQuantity'],
        'afterAdjustQuantity': json['afterAdjustQuantity'] == null ? undefined : json['afterAdjustQuantity'],
        'batchNo': json['batchNo'] == null ? undefined : json['batchNo'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'adjustTime': json['adjustTime'] == null ? undefined : json['adjustTime'],
    };
}

export function AdminStockAdjustRecordListResVoToJSON(json: any): AdminStockAdjustRecordListResVo {
    return AdminStockAdjustRecordListResVoToJSONTyped(json, false);
}

export function AdminStockAdjustRecordListResVoToJSONTyped(value?: AdminStockAdjustRecordListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adjustRecordNo': value['adjustRecordNo'],
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'skuCode': value['skuCode'],
        'adjustedQty': value['adjustedQty'],
        'adjustReasonCode': value['adjustReasonCode'],
        'adjustReason': value['adjustReason'],
        'operatorName': value['operatorName'],
        'beforeAdjustQuantity': value['beforeAdjustQuantity'],
        'afterAdjustQuantity': value['afterAdjustQuantity'],
        'batchNo': value['batchNo'],
        'locationNo': value['locationNo'],
        'adjustTime': value['adjustTime'],
    };
}

